import React from "react"

import styles from "./ChargingLoader.module.scss"

/**
 * ChargingLoader - Circular loading indicator for the public payment pages: a ring that turns around a pulsing
 * lightning bolt, in a neutral grey until the operator primary color is known, then in that color. Renders inline,
 * so the page header and footer stay visible, unlike the full-screen EVPOS wordmark loader.
 *
 * @component
 * @returns {JSX.Element} Animated charging circle
 */
export default function ChargingLoader() {
	return (
		<div className={styles["charging-loader"]}>
			<svg className={styles["charging-loader__svg"]} viewBox="0 0 64 64" aria-hidden="true" role="presentation">
				<circle className={styles["charging-loader__track"]} cx="32" cy="32" r="28" />
				<circle className={styles["charging-loader__arc"]} cx="32" cy="32" r="28" />
				<path className={styles["charging-loader__bolt"]} d="M35 14L21 34h9l-2 16 15-22h-9l1-14z" />
			</svg>
		</div>
	)
}
